import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["className", "children", "disableGutters", "fixed", "maxWidth"];
import React, { forwardRef } from 'react';
import { bool, string, node, elementType, oneOf } from 'prop-types';
import { Container as MuiContainer } from '@material-ui/core';
const Container = /*#__PURE__*/forwardRef(function Container(props, ref) {
  const {
      className,
      children,
      disableGutters,
      fixed,
      maxWidth
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(MuiContainer, Object.assign({}, rest, {
    className: className,
    disableGutters: disableGutters,
    fixed: fixed,
    maxWidth: maxWidth,
    ref: ref
  }), children);
});
Container.propTypes = {
  /**
   * The content of the component.
   */
  children: node,
  /**
   * The CSS class name of the wrapper element.
   */
  className: string,
  /**
   * The component used for the root node. Either a string to use a DOM element or a component.
   */
  component: elementType,
  /**
   * If true, the left and right padding is removed.
   */
  disableGutters: bool,
  /**
   * Set the max-width to match the min-width of the current breakpoint. This is useful if you'd prefer to design for a fixed set of sizes instead of trying to accommodate a fully fluid viewport. It's fluid by default.
   */
  fixed: bool,
  /**
   * Determine the max-width of the container. The container width grows with the size of the screen. Set to false to disable maxWidth
   */
  maxWidth: oneOf([false, 'xs', 'sm', 'md', 'lg', 'xl'])
};
Container.defaultProps = {
  disableGutters: false,
  fixed: false,
  maxWidth: 'lg',
  component: 'div'
};
export default Container;